import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { AtlasNewDto } from '../dto/AtlasNewDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, getLang, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const deleteAddAtlas3DNew = async (
  route: string,
  key: string,
  dto: AtlasNewDto
) => {
  const params: IApiParams = {
    url: `/deleteAtlasNew.php?baseName=${route}&keyTitle=${key}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
      'Api-Lang': getLang(),
    },
  };
  return getApi(params, 'POST', dto);
};
